import React from 'react';

const DerivadasSection = ({ orientacion, puntos, renderFormularioMateria, renderListaMaterias }) => {
  const puntosActuales = puntos.orientacionDerivadas || 0;
  const puntosRequeridos = orientacion.nombre === 'Derecho del Trabajo' ? 4 : 8;
  let descripcionEspecial = '';

  if (orientacion.nombre === 'Derecho Penal') {
    descripcionEspecial = 'Los primeros 2 puntos son condicionales: si elegiste "Parte Especial" como obligatoria, debés cursar "Introducción a las Teorías Criminológicas". Si elegiste "Criminología", debés cursar "Introducción a la Parte Especial".';
  } else if (orientacion.nombre === 'Derecho Empresarial') {
    descripcionEspecial = '4 puntos deben ser derivados de las materias no elegidas como obligatorias (2 puntos de cada una).';
  }

  return (
    <div>
      <div style={{
        backgroundColor: 'var(--bg-hover)',
        color: 'var(--text-primary)',
        padding: '10px 15px',
        borderRadius: '4px',
        marginBottom: '15px',
        border: '1px solid var(--border-color)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Puntos acumulados:</span>
          <span style={{ fontWeight: 'bold' }}>{puntosActuales}/{puntosRequeridos}</span>
        </div>
      </div>
      {descripcionEspecial && (
        <div style={{
          backgroundColor: 'var(--warning-bg)',
          color: 'var(--warning-text)',
          padding: '10px 15px',
          borderRadius: '4px',
          marginBottom: '15px',
          fontSize: '0.9em',
          border: '1px solid var(--warning-border)'
        }}>
          <strong>Importante:</strong> {descripcionEspecial}
        </div>
      )}
      {renderFormularioMateria('derivadas', puntosRequeridos)}
      {renderListaMaterias('derivadas', 'Materias Derivadas Cursadas')}
    </div>
  );
};

export default DerivadasSection;
